import React, { useEffect, useState } from 'react';
import Lenis from '@studio-freight/lenis'
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Article from './Article';
import Cover from './Cover';
import Editorial from './Editorial';
import Quote from './Quote';
import Intro from './Intro'
import Video from './Video'

import './App.scss';
gsap.registerPlugin(ScrollTrigger);
gsap.defaults({ease: "none"});

const path = process.env.PUBLIC_URL

function App() {
  const [currentIndex, setCurrentIndex] = useState(null);
  const [moonXY, setMoonXY] = useState([0, 0]);
  const [moonOpacity, setMoonOpacity] = useState(0);
  const [moving, setMoving] = useState(false);
  const [creditShow, setCreditShow] = useState(false)

  const allowCrossOrigin = (img, url) => {
    var image = new Image();
    image.src = url;
    image.onload = function() {
       img.src = url;
    };
 }

  useEffect(() => {
    // const lenis = new Lenis({
    //   duration: 1.2,
    //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    // });
    
    // function raf(time) {
    //   lenis.raf(time);
    //   ScrollTrigger.update();
    //   requestAnimationFrame(raf);
    // }

    // lenis.on('scroll', (e) => {
    //   console.log(e.velocity)
    //   if (e.velocity === 0) {
    //     setMoving(false)
    //   } else {
    //     setMoving(true)
    //   }
    // })
    
    // requestAnimationFrame(raf);
    
    const section_1 = document.getElementById("vertical");
    // let card_items = gsap.utils.toArray(".vertical__item");
    const timeln = gsap.timeline({ paused: true });
    
    // timeln.fromTo(col_left, {y: 0}, {y: '170vh', duration: 1, ease: 'none'}, 0);
    
    ScrollTrigger.create({
      animation: timeln,
      trigger: section_1,
      start: 'top top',
      end: 'bottom center',
      scrub: true,
    });
    
    const section_2 = document.getElementById("horizontal");
    let box_items = gsap.utils.toArray(".horizontal__item");
    let text_items = gsap.utils.toArray(".p-wrap .panel");
    let container = document.getElementsByClassName("mask-wrap")[0];


    ScrollTrigger.matchMedia({
      // desktop
      "(min-width: 769px)": function() {
        gsap.to(box_items, {
          xPercent: -100 * (box_items.length - 1),
          ease: "none",
          scrollTrigger: {
            trigger: section_2,
            pin: true,
            scrub: 3,
            snap: {
              snapTo: 1 / (box_items.length - 1),
              duration: 0.1,
              delay: 0.1,
              ease: "power1.inOut"
            },
            end: "+=" + section_2.offsetWidth,
            onUpdate: self => {
              const index = Math.round(self.progress * (box_items.length - 1))
              setCurrentIndex(index)
              if (Math.abs(self.progress * (box_items.length - 1) - index) < 0.001) {
                setMoonOpacity(0)
              } else {
                setMoonOpacity(1)
              }
            } 
          }
        }); 
        text_items.forEach((text_item, i) => {
          gsap.to(text_item, {
            y: container.clientHeight - 80 - text_item.clientHeight,
            scrollTrigger: {
              trigger: ".scroller",
              // pin: "#quote",
              scrub: true,
              start: "top top",
              end: "bottom bottom+=" + window.innerHeight * 0.05,
              // markers: true
            }
          });
        });
      },
      "(max-width: 768px)": function() {
        text_items.forEach((text_item, i) => {
          gsap.to(text_item, {
            y: container.clientHeight - 60 - text_item.clientHeight,
            scrollTrigger: {
              trigger: ".scroller",
              // pin: "#quote",
              scrub: true,
              start: "top top",
              end: "bottom bottom+=" + window.innerHeight * 0.05,
              // markers: true
            }
          });
        });
      },
    });
    // ScrollTrigger.create({
    //   trigger: "#quote",
    //   pin: true,
    //   start: "top top",
    //   end: "bottom top",
    // });

    ScrollTrigger.create({
      trigger: ".video .container",
      start: "top 10%",
      onLeaveBack: () => {
        setCreditShow(false)
      }
    });

    var remoteImage =  new Image();
    // remoteImage.src = 'https://s3cdn.wainao.me/react-static/special-reports/run/illus01.png';
    allowCrossOrigin(remoteImage, path + '/illus01.png');

  }, []);


  useEffect(() => {
    switch (currentIndex) {
      case 0:
        setMoonXY(['36.5vw', 'calc(100vh - 44.5vw)'])
        break;
      case 1:
        setMoonXY(['78.3vw', '12.2vh'])
        break;
      case 2:
        setMoonXY(['31.3vw', 'calc(100vh - 38.8vw)'])
        break;
      case 3:
        setMoonXY(['86.5vw', 'calc(100vh - 40.8vw)'])
        break;
      case 4:
        setMoonXY(['73.5vw', '14.6vh'])
        break;
      case 5:
        setMoonXY(['12vw', 'calc(100vh - 41vw)'])
        break;
      default:
        setMoonXY(['-6vw', '-6vh'])
    }
  }, [currentIndex]);

  return (
    <div className="App">
      <div className='bg' style={{ backgroundImage: `url(${path}/bg.jpg)`}} />
      <Cover />
      <Intro title="Buzzword"/>
      
      <section id="vertical">
        <div className="vertical__content">
          <div className="vertical__item">
            <Quote moving={moving} />
          </div>
          <div className="vertical__item">
            <Editorial
              index={'ver0'}
              currentIndex={currentIndex}
              title="<strong>Run</strong> is a form of passive resistance against the regime, yet it opens up new possibilities for social movement"
              subtitle="Commentary" />
          </div>
        </div>
      </section>
      
      <div className='horizontal__wrapper'>
        <section id="horizontal">
          <div className="horizontal__item">
            <Article
              size="large"
              index={0}
              currentIndex={currentIndex}
              direction="left bottom"
              imgSrc="illus01"
              svgSrc="line01"
              title="No money but wanting to flee: Studying abroad in Japan and working part-time jobs to strive for independence and a future"
              desc="Barely able to make ends meet at home, Lin Sen typically only eats 99 yen onigiri rolls from the supermarket and waits every day until the supermarket’s nightly discounts to buy bentos for dinner. While studying at night at a private school, she would sneak out to grab a bento from a nearby cheap supermarket."
              link="https://www.wainao.me/wainao-reads/running-as-foreign-students-en-07012023"
              type="article"
              subtitle="In-depth report" />
          </div>
          <div className="horizontal__item">
            <Article
              index={1}
              currentIndex={currentIndex}
              direction="right"
              imgSrc="illus02"
              svgSrc="line02"
              title="From a privileged class at home to marginalized foreigner: New middle class immigrants are voluntarily ‘devaluing’"
              desc="For those like Andy and Molly, having their money consumed by middleman agencies and their immigration process delayed, this may only be the tip of the iceberg of middleman chaos. Others encounter scams where they are told everything has been arranged… except for the actual immigration."
              link="https://www.wainao.me/wainao-reads/run-middle-class-new-immigrants-to-marginalized-foreigner-en-07012023"
              subtitle="In-depth report" />
          </div>
          <div className="horizontal__item">
            <Article
              size="large"
              index={2}
              currentIndex={currentIndex}
              direction="left bottom"
              imgSrc="illus03"
              svgSrc="line03"
              title="She’s leaving: but are the women who flee to the West any better off?"
              desc="When she started living in western Europe, Ruogui found that the women there were fiercely determined to stay. The men, not so much. Men who enjoy a privileged position back home feel more vulnerable when they leave China because they're suddenly seen as Asian."
              link="https://www.wainao.me/wainao-reads/women-who-run-en-07012023"
              subtitle="In-depth report" />
          </div>
          <div className="horizontal__item">
            <Article
              index={3}
              currentIndex={currentIndex}
              direction="right bottom"
              imgSrc="illus04"
              svgSrc="line04"
              title="Made homeless for being trans, I jumped off my plane in Switzerland"
              desc="Soon after Yiling was kicked out of her parents’ house for being transgender, the COVID-19 lockdown measures began, and her mental health started to deteriorate. When she called her parents to ask to be taken to hospital, rather than risk smuggling herself across international borders, they told her not to come home."
              link="https://www.wainao.me/wainao-watches/wainao-watches/runology-china-migrants-transgender-A4revolution-en"
              type="video"
              subtitle="Short video" />
          </div>
          <div className="horizontal__item">
            <Article
              index={4}
              currentIndex={currentIndex}
              direction="right"
              imgSrc="illus05"
              svgSrc="line05"
              title="Fleeing discrimination and oppression, ethnic minorities break through and go abroad"
              desc="In the end, Sawut spent 10,000 yuan bribing officials to get his passport. He then made trips to Turkey and Japan before applying to study in Japan. “It had to be a democracy. I didn't want to live in a totalitarian state,” he says. He quit his job at a railway company and left Xinjiang without looking back."
              link="https://www.wainao.me/wainao-reads/run-ethnic-minorities-discrimination-oppression-ethnic-oppression-en-07012023"
              subtitle="In-depth report" />
          </div>
          <div className="horizontal__item">
            <Article
              index={5}
              currentIndex={currentIndex}
              direction="left bottom"
              imgSrc="illus06"
              svgSrc="line06"
              title="The secret tide of ‘walking the line’: they risk their lives crossing a rainforest to illegally immigrate into the United States"
              desc="“The kids thought it was just a summer trip, and didn’t know that we were going to immigrate to the United States, let alone go there via the rainforest.” Weeks later, while watching the two children share the last piece of bread in their wet clothes in the rainforest, Ximen felt “guilty, heartache, but no regret.”"
              link="https://www.wainao.me/wainao-reads/run-trekking-smuggling-through-borders-en-07012023"
              subtitle="In-depth report" />
          </div>
          <svg style={{transform: `translate(${moonXY[0]}, ${moonXY[1]})`, opacity: moonOpacity}} className='moon' viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_480_20443)">
            <path d="M49.5 99C76.8381 99 99 76.8381 99 49.5C99 22.1619 76.8381 0 49.5 0C22.1619 0 0 22.1619 0 49.5C0 76.8381 22.1619 99 49.5 99Z" fill="url(#paint0_linear_480_20443)" fillOpacity="0.5"/>
            </g>
            <defs>
            <linearGradient id="paint0_linear_480_20443" x1="24.7459" y1="6.62506" x2="74.2541" y2="92.3777" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EBC291" stopOpacity="0.2"/>
            <stop offset="0.07" stopColor="#EAC298" stopOpacity="0.35"/>
            <stop offset="0.17" stopColor="#EAC2A0" stopOpacity="0.52"/>
            <stop offset="0.27" stopColor="#E9C3A7" stopOpacity="0.67"/>
            <stop offset="0.38" stopColor="#E9C3AD" stopOpacity="0.79"/>
            <stop offset="0.5" stopColor="#E9C3B1" stopOpacity="0.88"/>
            <stop offset="0.63" stopColor="#E9C3B4" stopOpacity="0.95"/>
            <stop offset="0.78" stopColor="#E9C3B6" stopOpacity="0.99"/>
            <stop offset="1" stopColor="#E9C4B7"/>
            </linearGradient>
            <clipPath id="clip0_480_20443">
            <rect width="99" height="99" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </section>
      </div>

      <Video
        title="Young Chinese are running: but are their dreams coming true?"
        desc="Artist Youxiang stayed in Minneapolis after marrying his husband. Living the “house husband” life. Azure got smuggled across the border to the United States, later finding a job as a masseur in Dallas.. Yiling, a transgender woman who fled to Switzerland due to social and domestic violence, still cares about transgender rights in China and speaks out for the “white paper movement.” WHYNOT takes you along on their journeys after they leave China, as they relive and reflect on their decisions to “run.”"
        subtitle="Mini documentary"
        creditShow={creditShow}
        setCreditShow={setCreditShow}
      />
    </div>
  );
}

export default App;
